/**
 * Modal for entering/editing project name before save
 */
export class SaveModal {
    constructor() {
        this.modal = null;
        this.input = null;
        this.onConfirm = null;
        this.onCancel = null;
        this.createElement();
    }

    /**
     * Create the modal DOM element
     */
    createElement() {
        // Create backdrop
        this.modal = document.createElement('div');
        this.modal.id = 'save-modal';
        this.modal.className = 'fixed inset-0 bg-black/70 backdrop-blur-sm z-[1003] hidden flex items-center justify-center';

        // Create modal content
        const modalContent = document.createElement('div');
        modalContent.className = 'bg-slate-800 rounded-xl shadow-2xl p-6 w-full max-w-md border border-slate-700';

        // Title
        const title = document.createElement('h3');
        title.className = 'text-xl font-semibold text-white mb-2';
        title.textContent = 'Nom du projet';

        // Description
        const description = document.createElement('p');
        description.className = 'text-sm text-slate-400 mb-4';
        description.textContent = 'Donnez un nom à votre projet 360° avant de le sauvegarder.';

        // Input
        this.input = document.createElement('input');
        this.input.type = 'text';
        this.input.className = 'w-full px-4 py-2 bg-slate-900 border border-slate-600 rounded-lg text-white placeholder-slate-400 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/50 mb-6';
        this.input.placeholder = 'Nom du projet...';

        // Buttons container
        const buttonsContainer = document.createElement('div');
        buttonsContainer.className = 'flex gap-3 justify-end';

        // Cancel button
        const cancelBtn = document.createElement('button');
        cancelBtn.className = 'px-4 py-2 bg-slate-700 hover:bg-slate-600 text-white rounded-lg transition-colors';
        cancelBtn.textContent = 'Annuler';
        cancelBtn.addEventListener('click', () => this.handleCancel());

        // Confirm button
        const confirmBtn = document.createElement('button');
        confirmBtn.className = 'px-4 py-2 bg-gradient-to-r from-green-600 to-blue-600 hover:from-green-700 hover:to-blue-700 text-white rounded-lg transition-all';
        confirmBtn.textContent = 'Sauvegarder';
        confirmBtn.addEventListener('click', () => this.handleConfirm());

        buttonsContainer.appendChild(cancelBtn);
        buttonsContainer.appendChild(confirmBtn);

        modalContent.appendChild(title);
        modalContent.appendChild(description);
        modalContent.appendChild(this.input);
        modalContent.appendChild(buttonsContainer);

        this.modal.appendChild(modalContent);
        document.body.appendChild(this.modal);

        // Handle Enter key
        this.input.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                this.handleConfirm();
            } else if (e.key === 'Escape') {
                this.handleCancel();
            }
        });

        console.log('✅ Save modal created');
    }

    /**
     * Show the modal
     * @param {string} currentTitle - Current project title (empty for new projects)
     * @param {Function} onConfirm - Callback when user confirms with title
     * @param {Function} onCancel - Callback when user cancels
     */
    show(currentTitle = '', onConfirm, onCancel) {
        this.onConfirm = onConfirm;
        this.onCancel = onCancel;
        this.input.value = currentTitle;
        this.modal.classList.remove('hidden');

        // Focus input and select text
        setTimeout(() => {
            this.input.focus();
            if (currentTitle) {
                this.input.select();
            }
        }, 100);

        console.log('💾 Save modal shown');
    }

    /**
     * Hide the modal
     */
    hide() {
        this.modal.classList.add('hidden');
        this.input.value = '';
        this.onConfirm = null;
        this.onCancel = null;
        console.log('💾 Save modal hidden');
    }

    /**
     * Handle confirm action
     */
    handleConfirm() {
        const projectTitle = this.input.value.trim();
        if (projectTitle && this.onConfirm) {
            this.onConfirm(projectTitle);
        } else if (!projectTitle) {
            // Show brief shake animation or error if no title
            this.input.classList.add('border-red-500');
            this.input.placeholder = 'Le nom est requis...';
            setTimeout(() => {
                this.input.classList.remove('border-red-500');
                this.input.placeholder = 'Nom du projet...';
            }, 2000);
            return;
        }
        this.hide();
    }

    /**
     * Handle cancel action
     */
    handleCancel() {
        if (this.onCancel) {
            this.onCancel();
        }
        this.hide();
    }

    /**
     * Remove the modal from DOM
     */
    dispose() {
        if (this.modal && this.modal.parentNode) {
            this.modal.parentNode.removeChild(this.modal);
            this.modal = null;
            console.log('✅ Save modal disposed');
        }
    }
}
